import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';

import Button from '../../../shared/_TBComponents/Button';
import { fetchLeaderboard } from '../ducks/leaderboardActions';

const ContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
`;

const Header = styled('div')`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 24px;
`;

const Title = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 600;
  color: #444444;
`;

const Subtitle = styled('span')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 400;
  color: #9e9e9e;
`;

const ConfirmText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  color: #444444;
`;

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`;

const buttonTextProps = { fontWeight: '600', letterSpacing: '0px' };

const DownloadBoardModal = ({
  closeModal,
  leaderboardId,
  boardNumber,
}) => {
  const leaderboardForm = useSelector(
    (state) => state.leaderboard.data.leaderboards[leaderboardId].leaderboardForm,
  );

  const dispatch = useDispatch();

  const downloadBoard = () => {
    dispatch(fetchLeaderboard(leaderboardForm, 'download', leaderboardId));
    closeModal();
  };

  return (
    <ContentWrapper>
      <Header>
        <Title>Export Leaderboard</Title>
        {boardNumber > 0 && <Subtitle>{`(Leaderboard ${boardNumber})`}</Subtitle>}
      </Header>
      <ConfirmText>Would you like to download this leaderboard as a CSV file?</ConfirmText>
      <ButtonContainer>
        <Button
          name='Download Board'
          bgColor='#444444'
          txtColor='white'
          noBorder
          fullWidth
          fontSize='14px'
          customBorderRadius='4px'
          styledTextProps={buttonTextProps}
          onClick={downloadBoard}
          type='button'
        />
        <Button
          name='Close'
          bgColor='white'
          borderColor='#444444'
          txtColor='#444444'
          fullWidth
          fontSize='14px'
          customBorderRadius='4px'
          styledTextProps={buttonTextProps}
          onClick={closeModal}
          type='button'
        />
      </ButtonContainer>
    </ContentWrapper>
  );
};

DownloadBoardModal.defaultProps = {
  boardNumber: 0,
};

DownloadBoardModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  leaderboardId: PropTypes.number.isRequired,
  boardNumber: PropTypes.number,
};

export default DownloadBoardModal;
